import { apiService } from '@/services/APIService';

export default {
  getTeams(id, params) {
    return apiService.get(`/public/events/${id}/teams`, params);
  },

  /**
   * Получение команд этапа
   * @param  {Number} id этап
   * @param {Object} params
   * @returns { Promise<Array<T>> } список команд
   */
  getEventStageTeams(id, params) {
    return apiService.get(`/event-stages/${id}/teams`, params);
  },

  getEventStageMembers(id, params) {
    return apiService.get(`/event-stages/${id}/members`, params);
  },

  // getEventStageFreeTeams(id, params) {
  //   return apiService.get(`/event-stages/${id}/teams/free`, params);
  // },

  // members

  getTeamPaticipiants(id, params) {
    return apiService.get(`/friend-teams/${id}/members`, params);
  },

  addMembersToTeam(id, params) {
    return apiService.put(`/teams/${id}/members/add`, params);
  },

  setCaptain(id, params) {
    return apiService.put(`/teams/${id}/members/transfer-captain`, params);
  },

  // This method delete member with role captain
  removeCaptain(id, params) {
    return apiService.put(`/teams/${id}/members/remove-captain`, params);
  },

  unsetCaptain(id, params) {
    return apiService.put(`/teams/${id}/members/unset-captain`, params);
  },

  // EVENT STAGE  TEAM

  getStageTeams(params) {
    return apiService.get('/teams', params);
  },

  showStageTeam(id, params) {
    return apiService.get(`/teams/${id}`, params);
  },

  createStageTeam(params) {
    return apiService.post('/teams', params);
  },

  considerStageTeam(id, params) {
    return apiService.post(`teams/${id}/consider`, params);
  },

  rejectStageTeam(id, params) {
    return apiService.post(`teams/${id}/reject`, params);
  },

  confirmStageTeam(id, params) {
    return apiService.post(`teams/${id}/confirm`, params);
  },

  updateStageTeam(id, params) {
    return apiService.put(`/teams/${id}`, params);
  },

  excludeEventStageMembers(id, params) {
    return apiService.put(`/teams/${id}/members/exclude`, params);
  },

  dissolutionMembers(id, params) {
    return apiService.put(`/teams/${id}/members/dissolution`, params);
  },

  leaveStageTeam(id, params) {
    return apiService.put(`/teams/${id}/leave`, params);
  },

  stageJoinHash(id) {
    return apiService.post(`/teams/${id}/members/join-hash`);
  },

  deleteTeam(id) {
    return apiService.delete(`/teams/${id}`);
  },

  getMyTeams(params) {
    return apiService.get('/teams/my-teams/', params);
  },

  // members

  teamSync(id, params) {
    return apiService.put(`/teams/${id}/sync`, params);
  },

  getStageParticipants(id, params) {
    return apiService.get(`/teams/${id}/members`, params);
  },

  joinByInvitionEventTeam(params) {
    return apiService.post('/teams/join-by-invitation', params);
  },

  joinEventTeam(id) {
    return apiService.post(`/teams/${id}/join`, id);
  },

  confirmEventMembers(id, params) {
    return apiService.put(`/teams/${id}/members/confirm`, params);
  },

  rejectEventMembers(id, params) {
    return apiService.put(`/teams/${id}/members/reject`, params);
  },

  generateEventTeamHash(id) {
    return apiService.post(`/teams/${id}/join-hash`);
  },

  getTeamHistories(params) {
    return apiService.get('/team-histories', params);
  },

  acceptAllStageTeams(stageId, params) {
    return apiService.post(`/event-stages/${stageId}/teams/confirm-all`, params);
  },

  // EVENT TEAMS
  getEventTeamsList(params) {
    return apiService.get(`/teams`, params);
  },

  getTeamEvent(id, params) {
    return apiService.put(`/teams/event/${id}`, params);
  },

  completeTeam(id, params) {
    return apiService.post(`/teams/${id}/complete`, params);
  },

  addTeamOrganizer(id, params) {
    return apiService.put(`/teams/${id}/add-organizer`, params);
  },

  unsetTeamOrganizer(id, params) {
    return apiService.put(`/teams/${id}/unset-organizer`, params);
  },

  // Coaching teams
  coachingJoinHash(id) {
    return apiService.post(`/coaching-teams/${id}/join-hash`);
  },
  coachingMyTeams(params) {
    return apiService.get('/coaching-teams/my-teams', params);
  },
  coachingLeave(id, params) {
    return apiService.put(`/coaching-teams/${id}/members/leave`, params);
  },
  coachingExclude(id, params) {
    return apiService.put(`/coaching-teams/${id}/members/exclude`, params);
  },
  coachingJoin(params) {
    return apiService.put('/coaching-teams/join-by-hash', params);
  },

  // Coahing teams / create event request

  // -- ДЛЯ ТРЕНЕРА
  eventTeamRequests(params) {
    return apiService.get(`/request-team-member-lists`, params);
  },
  eventTeamRequest(id, params) {
    return apiService.get(`/request-team-member-lists/${id}`, params);
  },
  createEventTeamRequest(params) {
    return apiService.post(`/request-team-member-lists`, params);
  },
  removeEventTeamRequest(id) {
    return apiService.delete(`/request-team-member-lists/${id}`);
  },
  sendEventTeamRequest(id) { // Отправляет заявку команды организатору!!!
    return apiService.post(`/request-team-member-lists/${id}/request`);
  },
  addEventTeamRequestMembers(id, params) { // params { user_ids: { id: Number, is_captain: Boolean }[] }
    return apiService.put(`/request-team-member-lists/${id}/attach?expand=members`, params);
  },
  removeEventTeamRequestMembers(id, params) { //  params { user_ids: Number[] }
    return apiService.put(`/request-team-member-lists/${id}/detach?expand=members`, params);
  },
  setCaptainEventTeamRequest(id, params) { // params { user_id: Number }
    return apiService.put(`/request-team-member-lists/${id}/set-captain?expand=members`, params);
  },
  // -- ДЛЯ ОРГАНИЗАТОРА
  checkEventTeamRequest(id) { // Проверяет, подходит ли заявка команды условиям
    return apiService.post(`/request-team-member-lists/${id}/check`);
  },
  registerEventTeamRequest(id, params) { // params { name: String }
    return apiService.post(`/request-team-member-lists/${id}/register`, params);
  },
  rejectEventTeamRequest(id, params) {
    return apiService.post(`/request-team-member-lists/${id}/reject`, params);
  },
  incorrectEventTeamRequest(id, params) {
    return apiService.post(`/request-team-member-lists/${id}/incorrect-documents`, params);
  },
  considerEventTeamRequest(id, params) {
    return apiService.post(`/request-team-member-lists/${id}/consider`, params);
  },

  // Friend teams
  friendsMyTeams() {
    return apiService.get('/friend-teams/my-teams');
  },
  getFriendsTeams(params) {
    return apiService.get('/friend-teams', params);
  },
  showFriendTeam(id, params) {
    return apiService.get(`/friend-teams/${id}`, params);
  },
  createFriendTeam(params) {
    return apiService.post('/friend-teams', params);
  },
  updateFriendTeam(id, params) {
    return apiService.put(`/friend-teams/${id}`, params);
  },
  friendsJoin(params) {
    return apiService.post('/friend-teams/join', params);
  },
  friendsLeave(id, params) {
    return apiService.put(`/friend-teams/${id}/leave`, params);
  },
  friendsExclude(id, params) {
    return apiService.put(`/friend-teams/${id}/exclude`, params);
  },
  friendsConfirmFriends(id, params) {
    return apiService.put(`/friend-teams/${id}/confirm`, params);
  },
  friendsChangeOwner(id, params) {
    return apiService.put(`/friend-teams/${id}/change-owner`, params);
  },
  friendsJoinHash(id) {
    return apiService.post(`/friend-teams/${id}/join-hash`);
  },

  // Team roles & templates

  getRoles(params) {
    return apiService.getCached('/team-roles', params);
  },

  showRole(id, params) {
    return apiService.get(`/team-roles/${id}`, params);
  },

  createRole(params) {
    return apiService.post('/team-roles', params);
  },

  updateRole(id, params) {
    return apiService.put(`/team-roles/${id}`, params);
  },

  deleteRole(id, params) {
    return apiService.delete(`/team-roles/${id}`, params);
  },

  getPatterns(params) {
    return apiService.get('/team-patterns', params);
  },

  showPattern(id, params) {
    return apiService.get(`/team-patterns/${id}`, params);
  },

  createPattern(params) {
    return apiService.post('/team-patterns', params);
  },

  updatePattern(id, params) {
    return apiService.put(`/team-patterns/${id}`, params);
  },

  deletePattern(id, params) {
    return apiService.delete(`/team-patterns/${id}`, params);
  },

  getPatternRights(params) {
    return apiService.get('/team-pattern-rights', params);
  },

  createPatternRight(params) {
    return apiService.post('/team-pattern-rights', params);
  },

  deletePatternRight(id, params) {
    return apiService.delete(`/team-pattern-rights/${id}`, params);
  },

  attachRoleToPattern(id, params) {
    return apiService.post(`/team-patterns/${id}/attach-roles`, params);
  },

  detachRoleToPattern(id, params) {
    return apiService.post(`/team-patterns/${id}/detach-roles`, params);
  },

  updatePatternRole(idPattern, idRole, params) {
    return apiService.put(`/team-patterns/${idPattern}/team-roles/${idRole}`, params);
  },

  attachEventToPattern(patternId, eventId, params) {
    return apiService.post(`/team-patterns/${patternId}/events/${eventId}/attach`, params);
  },

  detachEventToPattern(patternId, eventId, params) {
    return apiService.post(`/team-patterns/${patternId}/events/${eventId}/detach`, params);
  },

  changeMemberRole(teamId, memberId, params) {
    return apiService.put(`/teams/${teamId}/members/${memberId}/change-role`, params);
  },

  // Teams for transfer

  createTransferTeam(params) {
    return apiService.post('/teams/for-transfer', params);
  },

  updateTransferTeam(id, params) {
    return apiService.put(`/teams/for-transfer/${id}`, params);
  },

  excludeMembersByOwner(id, params) {
    return apiService.put(`/teams/${id}/members/remove-by-owner`, params);
  },

  addMembersByOwner(id, params) {
    return apiService.put(`/teams/${id}/members/add-by-owner`, params);
  },
};
